import {useRoute, computed} from "#imports";

// `useRequestURL()`은 `nuxt generate` 프리렌더 시점에 http://localhost/ 를 반환해
// canonical/hreflang이 전부 localhost로 박제됐다(SEO 요구사항 A-1). 정적 배포라
// 요청 origin을 알 수 없으므로 실제 서비스 도메인을 상수로 사용한다.
// (sitemap용 `site.url`, useSiteNavigationLd와 동일한 값)
const SITE_URL = 'https://codepresso.io';

export const useSeoMeta = () => {
  // Nuxt composable들을 Vue setup 함수 내에서만 호출되도록 보장
  const route = useRoute();

  // 원본 path 추출 (언어 prefix 제거)
  const getOriginPath = computed(() => {
    return route.path.replace(/^\/(en|ja|ko|es|vi)/, '');
  });

  // canonical URL 계산
  const getCanonical = computed(() => {
    return new URL(getOriginPath.value, SITE_URL).toString();
  });

  // hreflang 태그 생성 — 현재 i18n strategy가 no_prefix라 /ko, /en 같은
  // 언어별 경로가 실제로 존재하지 않는다(요청 시 SPA fallback 셸이 내려감).
  // 존재하지 않는 URL을 alternate로 선언하면 검색엔진 신호가 어긋나므로,
  // 언어별 프리렌더(A-6)가 생기기 전까지는 hreflang을 내보내지 않는다.
  const getHreflangLinks = computed(() => []);

  return {
    getOriginPath,
    getCanonical,
    getHreflangLinks
  };
};
